// extracted by mini-css-extract-plugin
module.exports = {"container":"PromotionsSeenByAge_container__2mysH","header":"PromotionsSeenByAge_header__1Nlj4"};